import { render, staticRenderFns } from "./FailureStatusEmailTab.vue?vue&type=template&id=3b74aeb7&scoped=true&"
import script from "./FailureStatusEmailTab.vue?vue&type=script&lang=js&"
export * from "./FailureStatusEmailTab.vue?vue&type=script&lang=js&"
import style0 from "./FailureStatusEmailTab.vue?vue&type=style&index=0&id=3b74aeb7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b74aeb7",
  null
  
)

export default component.exports